import { iRequest } from '@/utils/requestutil';

export async function save(payload) {
  return iRequest(`/iwms-openapi/api/erp`, {
    method: 'POST',
    body: payload,
  });
}

export async function query(payload) {
  return iRequest(`/iwms-openapi/api/erp/query`, {
    method: 'POST',
    body: payload,
  });
}

export async function modify(payload) {
  return iRequest(`/iwms-openapi/api/erp/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function modifyHttpExtend(payload) {
  return iRequest(
    `/iwms-openapi/api/erp/modifyHttpExtend?uuid=${payload.uuid}`,
    {
      method: 'POST',
      body: payload.extendInfo,
    },
  );
}

export async function remove(payload) {
  return iRequest(`/iwms-openapi/api/erp/remove?uuid=${payload.uuid}`, {
    method: 'POST',
  });
}

export async function get(payload) {
  return iRequest(`/iwms-openapi/api/erp/${payload.uuid}`);
}

export async function geterpType(payload) {
  return iRequest(`/iwms-openapi/api/erp/geterpType`);
}
